import React, { useState } from 'react';
import './FAQ.css';
import { faqDataObject } from '../../API/Resources/FAQ/faqData'

const FAQ = () => {
    // We no longer need to flatten the array. We will use the original nested structure.
    const { categories } = faqDataObject;

    return (
        <div className="faq-section container">
            <h2 className="faq-title">Frequently Asked Questions</h2>

            {/* Outer Loop: Iterate over each CATEGORY */}
            {categories.map((category) => (
                // Use a React Fragment or a <section> for each category group
                <React.Fragment key={category.name}>
                    <h3 className="faq-category-title mt-3">{category.name}</h3>
                    <div className="faq-container">

                        {/* Inner Loop: Iterate over the FAQs within this specific category */}
                        {category.faqs.map((item, index) => (
                            <div className="faq-item" key={index}>
                                <div className="faq-question">
                                    <h4>{item.question}</h4>
                                </div>
                                <div
                                    className="faq-answer"
                                    dangerouslySetInnerHTML={{ __html: item.answer }}
                                />
                            </div>
                        ))}

                    </div>
                </React.Fragment>
            ))}
        </div>
    );
};

export default FAQ;